<template>
    <div v-if="subFormAvailable">
        <b-row class="d-flex align-items-center klippa-subform-header">
            <h2>
                Kunde
            </h2>
            <b-button
                class="klippa-subform-toggle-btn"
                variant="primary"
                @click="toggleAll">
                {{ someIncluded ? 'Alle abwählen' : 'Alle auswählen' }}
            </b-button>
        </b-row>
        <b-row>
            <b-col>
                <b-row>
                    <csp-klippa-info-card-element
                        ref="fieldFirstName"
                        class="col-12"
                        :form-context="formContext"
                        label="Vorname"
                        property="firstName"
                        :subform-identifier="subformIdentifier"
                        type="text"
                        @field-hover-changed="(data) => {$emit('field-hover-changed', data)}"
                        @field-inclusion-changed="onFieldInclusionChangedWithTracking"/>
                </b-row>
                <b-row>
                    <csp-klippa-info-card-element
                        ref="fieldLastName"
                        class="col-12"
                        :form-context="formContext"
                        label="Nachname"
                        property="lastName"
                        :subform-identifier="subformIdentifier"
                        type="text"
                        @field-hover-changed="(data) => {$emit('field-hover-changed', data)}"
                        @field-inclusion-changed="onFieldInclusionChangedWithTracking"/>
                </b-row>
                <b-row>
                    <csp-klippa-info-card-element
                        ref="fieldCompanyName"
                        class="col-12"
                        :form-context="formContext"
                        label="Firmenname"
                        property="companyName"
                        :subform-identifier="subformIdentifier"
                        type="text"
                        @field-hover-changed="(data) => {$emit('field-hover-changed', data)}"
                        @field-inclusion-changed="onFieldInclusionChangedWithTracking"/>
                </b-row>
                <b-row>
                    <csp-klippa-info-card-element
                        ref="fieldStreet"
                        class="col-12"
                        :form-context="formContext"
                        label="Straße"
                        property="street"
                        :subform-identifier="subformIdentifier"
                        type="text"
                        @field-hover-changed="(data) => {$emit('field-hover-changed', data)}"
                        @field-inclusion-changed="onFieldInclusionChangedWithTracking"/>
                </b-row>
                <b-row>
                    <csp-klippa-info-card-element
                        ref="fieldPostalCode"
                        class="col-12"
                        :form-context="formContext"
                        label="PLZ"
                        property="postalCode"
                        :subform-identifier="subformIdentifier"
                        type="text"
                        @field-hover-changed="(data) => {$emit('field-hover-changed', data)}"
                        @field-inclusion-changed="onFieldInclusionChangedWithTracking"/>
                </b-row>
                <b-row>
                    <csp-klippa-info-card-element
                        ref="fieldPlace"
                        class="col-12"
                        :form-context="formContext"
                        label="Ort"
                        property="place"
                        :subform-identifier="subformIdentifier"
                        type="text"
                        @field-hover-changed="(data) => {$emit('field-hover-changed', data)}"
                        @field-inclusion-changed="onFieldInclusionChangedWithTracking"/>
                </b-row>
                <b-row>
                    <csp-klippa-info-card-element
                        ref="fieldCountry"
                        class="col-12"
                        :form-context="formContext"
                        label="Land"
                        :options-loader="loadCountryOptions"
                        property="country"
                        :subform-identifier="subformIdentifier"
                        type="autocomplete"
                        @field-hover-changed="(data) => {$emit('field-hover-changed', data)}"
                        @field-inclusion-changed="onFieldInclusionChangedWithTracking"/>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import Container from '@services/Container';
import FormDataMixin from '@desktop/components/mixins/FormDataMixin';

const container = Container.getInstance();
const recordRepository = container.getDesktopRecordRepository();

const FIELD_REFS = [
    'fieldFirstName',
    'fieldLastName',
    'fieldCompanyName',
    'fieldStreet',
    'fieldPostalCode',
    'fieldPlace',
    'fieldCountry',
];

export default {
    name: 'DataApplicationCustomerSubForm',
    mixins: [FormDataMixin],
    props: {
        formContext: {
            type: Object,
            required: true,
        },
    },
    emits: [
        'field-inclusion-changed',
        'field-hover-changed',
    ],
    data() {
        return {
            fieldInclusionStates: {},
            subformIdentifier: 'customer',
        }
    },
    computed: {
        someIncluded() {
            const values = Object.values(this.fieldInclusionStates);
            return values.length === 0 || values.some((v) => v);
        },
        subFormAvailable() {
            if (!this.subformIdentifier) {
                return false;
            }
            if (!Array.isArray(this.formContext.subformIdentifiers)) {
                return false;
            }
            return this.formContext.subformIdentifiers.indexOf(this.subformIdentifier) !== -1;
        },
    },
    methods: {
        loadCountryOptions() {
            return recordRepository.loadLegacySelectOptions('countries')
        },
        onFieldInclusionChangedWithTracking(data) {
            this.$set(this.fieldInclusionStates, data.property, data.included);
            this.$emit('field-inclusion-changed', data);
        },
        toggleAll() {
            const target = !this.someIncluded;
            FIELD_REFS.forEach((refName) => {
                const ref = this.$refs[refName];
                if (ref) {
                    ref.setIncluded(target);
                }
            });
        },
    },
}
</script>
